import { Injectable } from "@angular/core";
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

export type GetNvalPeriodCSVResponce = {
  FileName: string,
}

/**
 * プロモ商品企画点検リスト出力クラス
 *
 * @export GetNvalPeriodCSVService
 * @class GetNvalPeriodCSVService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetNvalPeriodCSVService extends PlessJsonResponderSub<GetNvalPeriodCSVResponce> {

  // 処理に使用するModel
  private vo: any;
  private successFunc: Function = () => { };

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエスト
   * @memberof GetNvalPeriodCSVService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.vo.mediumType,
        BundleCatalogRoundId: this.vo.bundleCatalogRoundId,
        OrderCode: this.vo.orderCode,
        PCode: this.vo.pCode,
        ItemCode: this.vo.itemCode,
        OrderNum: this.vo.orderNum,
        StartOrderCode: this.vo.startOrderCode,
        EndOrderCode: this.vo.endOrderCode,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetNvalPeriodCSVService
   */
  execute(vo: any, successFunc: Function): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getNvalPeriodCSV', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetNvalPeriodCSVService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
